import { formatInTimeZone } from 'date-fns-tz';
import { es } from 'date-fns/locale';

const DEFAULT_TIMEZONE = 'America/Mexico_City';
const DEFAULT_LOCALE = es;

const parseDateInput = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      const [year, month, day] = trimmed.split('-').map(Number);
      return new Date(year, month - 1, day, 12, 0, 0);
    }
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const safeDate = (value) => parseDateInput(value);

export const parseLocalDate = (value) => parseDateInput(value);

export const formatLocalDate = (value, pattern = "EEEE d 'de' MMMM yyyy") => {
  const date = safeDate(value);
  if (!date) return '';
  return formatInTimeZone(date, DEFAULT_TIMEZONE, pattern, { locale: DEFAULT_LOCALE });
};

export const formatLocalTime = (value, pattern = 'HH:mm') => {
  const date = safeDate(value);
  if (!date) return '';
  return formatInTimeZone(date, DEFAULT_TIMEZONE, pattern, { locale: DEFAULT_LOCALE });
};

export const getMexicoDateString = (value = new Date()) => {
  const date = safeDate(value) || new Date();
  return formatInTimeZone(date, DEFAULT_TIMEZONE, 'yyyy-MM-dd', { locale: DEFAULT_LOCALE });
};
